"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrongSociety = void 0;
var GlobalEventName_1 = require("./GlobalEventName");
var PartyName_1 = require("../parties/PartyName");
var Resources_1 = require("../../Resources");
var CardRenderer_1 = require("../../cards/render/CardRenderer");
var Size_1 = require("../../cards/render/Size");
var RENDER_DATA = CardRenderer_1.CardRenderer.builder(function (b) {
    b.megacredits(2).slash().city().influence({ size: Size_1.Size.SMALL });
});
var StrongSociety = (function () {
    function StrongSociety() {
        this.name = GlobalEventName_1.GlobalEventName.STRONG_SOCIETY;
        this.description = 'Gain 2 M€ for each City tile (max 5) and influence.';
        this.revealedDelegate = PartyName_1.PartyName.REDS;
        this.currentDelegate = PartyName_1.PartyName.MARS;
        this.renderData = RENDER_DATA;
    }
    StrongSociety.prototype.resolve = function (game, turmoil) {
        var _this = this;
        game.getPlayers().forEach(function (player) {
            var amount = Math.min(5, player.getCitiesCount()) + turmoil.getPlayerInfluence(player);
            if (amount > 0) {
                player.addResource(Resources_1.Resources.MEGACREDITS, amount * 2, { log: true, from: _this.name });
            }
        });
    };
    return StrongSociety;
}());
exports.StrongSociety = StrongSociety;
